export const API_VERSION = 'v2'
export const API_URL = `/api/enrollment/${API_VERSION}`
